import { IMessageAttachment } from './message-attachment.interface';

export interface IConversationFile {
  fileId: string;
  /** Só quem tem este id pode ser reenviado. */
  attachmentId?: string;
  name: string;
  meta: string;
  icon: string;
  iconBg: string;
  iconColor: string;
  attachment: IMessageAttachment;
}

/** Teto do contrato: `attachment_ids` aceita no máximo cinco por mensagem. */
export const MAX_ATTACHMENTS_PER_MESSAGE = 5;
